import { useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useMenuNavigationStyles } from '../menuStyles/menuNavigationStyles';
import HeaderEnum from '../topLevelMenu/headerEnum';
import { TopLevelMenu } from '../topLevelMenu/TopLevelMenu';

interface BaseMenuProps {
  headerEnum: HeaderEnum;
  className: string;
  menuListClassName: string;
}

const BaseMenu: React.FC<BaseMenuProps> = ({ headerEnum, className, menuListClassName }) => {
  const theme = useTheme();
  const styles = useMenuNavigationStyles(theme);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/${headerEnum}`);
  };

  return (
    <TopLevelMenu
      alternateTitle={headerEnum}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      className={`${className} ${styles.root}`}
      menuListClassName={menuListClassName}
      titleEnum={headerEnum}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      onClick={handleClick}
    />
  );
};

export default BaseMenu;
